import React from 'react';
import { Link } from 'react-router-dom';
import { FaBell } from 'react-icons/fa';
import Button from '../../../components/Button/Button';
import SurveyStatusPill from './SurveyStatusPill';

const SurveyDetailHeader = ({ survey, onExportCsv, onRemindPending }) => {
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  return (
    <div className="survey-detail-header">
      <Link to="/surveys" className="btn btn-light survey-detail-back-btn">&larr; Surveys</Link>
      <h4 className="survey-detail-title">{survey.title}</h4>
      <div className="survey-detail-header-actions">
        <SurveyStatusPill status={Number(survey.status) === 1 ? 'active' : 'ended'} />
        <Button variant="light" onClick={onExportCsv}>&darr; Export CSV</Button>
        {permissions && permissions.includes('survey.update') && (
          <Button variant="primary" onClick={onRemindPending}>
            <FaBell className="me-1" /> Remind pending
          </Button>
        )}
      </div>
    </div>
  );
};

export default SurveyDetailHeader;
